import React, { useEffect, useState } from "react";
import { db } from "../../db/firebaseConfig";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const OrdenesAdmin = () => {
  const [ordenes, setOrdenes] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const q = query(collection(db, "orders"), orderBy("date", "desc"));
        const snapshot = await getDocs(q);
        const lista = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setOrdenes(lista);
      } catch (error) {
        console.error("Error al obtener las órdenes:", error);
      }
    };

    fetchOrders();
  }, []);

  const generarPDF = (order) => {
    const doc = new jsPDF();

    // Encabezado
    doc.setFontSize(14);
    doc.text("Comprobante de Pedido (No fiscal)", 14, 16);
    doc.setFontSize(10);
    doc.text(`Orden: ${order.id}`, 14, 22);
    doc.text(
      `Fecha: ${
        order.date?.seconds
          ? new Date(order.date.seconds * 1000).toLocaleString("es-AR")
          : "Sin fecha"
      }`,
      14,
      28
    );
    doc.text(`Cliente: ${order.buyer?.name || "N/A"}`, 14, 34);
    doc.text(
      `Email: ${order.buyer?.email || "N/A"}  Tel: ${
        order.buyer?.phone || "N/A"
      }`,
      14,
      40
    );
        doc.setFontSize(10);
    doc.text(
      "Este documento no representa una factura ni pago realizado.",
      14,
      52
    );
    doc.text(
      "El pedido será confirmado y abonado en el local Ortopedia Nuevo Horizonte, Los Inmigrantes 368.- San Jose de la Dormida.",
      14,
      58
    );

    // Tabla de items
    const rows = order.items?.map((it) => [
      it.name,
      it.quantity,
      new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: "ARS",
      }).format(it.price),
      new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: "ARS",
      }).format(it.subtotal),
    ]);

    autoTable(doc, {
    head: [["Producto", "Cant.", "Precio", "Subtotal"]],
    body: rows,
    startY: 66,
  });
    // Total
    const totalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(12);
    doc.text(
      `Total: ${new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: "ARS",
      }).format(order.total)}`,
      14,
      totalY
    );

    doc.save(`orden-${order.id}.pdf`);
  };

  return (
    <div className="p-6 bg-white rounded shadow-md">
      <h2 className="text-2xl font-bold mb-4">📑 Órdenes recientes</h2>

      {ordenes.length === 0 ? (
        <p>No hay órdenes registradas.</p>
      ) : (
        <table className="w-full border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="border p-2">Fecha</th>
              <th className="border p-2">Cliente</th>
              <th className="border p-2">Email</th>
              <th className="border p-2">Teléfono</th>
              <th className="border p-2">Total</th>
              <th className="border p-2">Detalle</th>
              <th className="border p-2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {ordenes.map((order) => (
              <tr key={order.id}>
                <td className="border p-2">
                  {order.date?.seconds
                    ? new Date(order.date.seconds * 1000).toLocaleString("es-AR")
                    : "Sin fecha"}
                </td>
                <td className="border p-2">{order.buyer?.name || "N/A"}</td>
                <td className="border p-2">{order.buyer?.email || "N/A"}</td>
                <td className="border p-2">{order.buyer?.phone || "N/A"}</td>
                <td className="border p-2">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(order.total || 0)}
                </td>
                <td className="border p-2">
                  {order.items?.map((it) => (
                    <div key={it.id}>
                      {it.name} (x{it.quantity}) - $
                      {new Intl.NumberFormat("es-AR").format(it.subtotal)}
                    </div>
                  ))}
                </td>
                <td className="border p-2 text-center">
                  <button
                    onClick={() => generarPDF(order)}
                    className="px-3 py-1 bg-blue-600 text-white rounded"
                  >
                    Generar PDF
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OrdenesAdmin;
